import { CacheProvider } from "../db/CacheProvider.js";
import { ItemStore } from "../db/ItemStore.js";
import { QueryStore } from "../db/QueryStore.js";
import { setMapItem } from "../util/map.js";
import { getOptionalSource } from "../util/source.js";
import { createCacheContext } from "./createCacheContext.js";
import { useStore } from "./useStore.js";
/**
 * Create a data context that can be provided to React elements and allows them to call `useItem()` and `useQuery()`
 */
export function createDataContext(provider) {
    const { CacheContext, useCache } = createCacheContext(); // eslint-disable-line @typescript-eslint/no-explicit-any
    // If this provider is backed by an in-memory cache, pass it to the `ItemStore` and `QueryStore` instances we create.
    const memory = getOptionalSource(CacheProvider, provider)?.memory;
    return {
        useItem: (collection, id) => {
            const cache = useCache();
            const key = collection && id && `${collection}/${id}`;
            return useStore(key ? cache.get(key) || setMapItem(cache, key, new ItemStore(collection, id, provider, memory)) : undefined);
        },
        useQuery: (collection, query) => {
            const cache = useCache();
            const key = collection && query && `${collection}?${JSON.stringify(query)}`;
            return useStore(key ? cache.get(key) || setMapItem(cache, key, new QueryStore(collection, query, provider, memory)) : undefined);
        },
        DataContext: CacheContext,
    };
}
